import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Diamond02 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "diamond02",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.0003 22h14m-16.5-14h19m-11.5-6-2 6 4 10.5 4-10.5-2-6m-1.408 16.3489 8.9396-9.8336c.166-.1827.2491-.274.2821-.378a.4995.4995 0 0 0 .0061-.2825c-.0285-.1053-.1076-.2001-.2656-.3898l-4.3143-5.1772c-.0882-.1058-.1322-.1587-.1863-.1967a.4997.4997 0 0 0-.1579-.074C16.8322 2 16.7634 2 16.6256 2H7.375c-.1377 0-.2066 0-.2704.0172a.5.5 0 0 0-.1578.074c-.054.038-.0982.0908-.1863.1966L2.4462 7.465c-.158.1896-.237.2845-.2657.3898a.5.5 0 0 0 .0061.2825c.0331.104.1161.1953.2822.378l8.9396 9.8336c.2052.2257.3078.3386.4284.3803a.4997.4997 0 0 0 .3271 0c.1206-.0417.2232-.1546.4284-.3803Z"
    })
  }));
};
export default Diamond02;